export type SavedInputState = {
  text: string;
  selectionStart: number;
  selectionEnd: number;
};

export const insertTranscriptIntoText = (
  saved: SavedInputState,
  transcript: string,
): { text: string; cursorPosition: number } => {
  const selectionStart = Math.max(0, Math.min(saved.selectionStart, saved.text.length));
  const selectionEnd = Math.max(selectionStart, Math.min(saved.selectionEnd, saved.text.length));
  const before = saved.text.slice(0, selectionStart);
  const after = saved.text.slice(selectionEnd);
  const startsWithWordCharacter = /^[\p{L}\p{N}]/u;
  const endsWithText = /[\p{L}\p{N},.;:!?…)}\]»”’]$/u;
  const separatorBefore = endsWithText.test(before) && startsWithWordCharacter.test(transcript) ? " " : "";
  const separatorAfter = endsWithText.test(transcript) && startsWithWordCharacter.test(after) ? " " : "";

  return {
    text: before + separatorBefore + transcript + separatorAfter + after,
    cursorPosition: before.length + separatorBefore.length + transcript.length,
  };
};
